import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectFlagsConfig } from '@/store/selectors';
import { useFeatureFlag } from '@/hooks/config/useFeatureFlag.hook';
import { logger } from '@/utils/logger/logger';

// Publishes raw consent facts for GrowthBook targeting. Deliberately raw — a
// derived status here would duplicate the helpers in utils/helpers/opt-in.
export const useConsentAttributesSync = (): void => {
  const flags = useSelector(selectFlagsConfig);
  const { updateAttributes } = useFeatureFlag();

  const eulaAgreed = Boolean(flags?.eulaAgreed);
  const onNewOptInSchema = flags?.onNewOptInSchema === true;
  const optInPreferences = Array.isArray(flags?.optInPreferences)
    ? flags.optInPreferences
    : null;
  // Compare by content, not array identity, so an equal re-dispatch doesn't re-fire this.
  const preferencesKey = optInPreferences ? optInPreferences.join(',') : '';

  useEffect(() => {
    updateAttributes({
      eulaAgreed,
      optInPreferences,
      onNewOptInSchema,
    }).catch(error => {
      logger.error('consent attributes sync failed', error);
    });
  }, [eulaAgreed, onNewOptInSchema, preferencesKey]);
};
